import Form from "./Form";
export default Form;


// WEBPACK FOOTER //
// ./src/Form/index.js